import { Select, styled as MUIStyled } from "@mui/material";
import styled from "styled-components";

export const CMDropdown = MUIStyled(Select)((props) => ({
  width: "100%",
  minWidth: "100px",
    maxWidth: "200px",
    height: "31px",
  borderRadius: "4px",
  backgroundColor: "#fff",

  "&.MuiInputBase-readOnly": {
    "& > fieldset": {
      border: "unset !important",
    },

    "& svg": {
      display: "none",
    },
  },

  "& > fieldset": {
    top: 0,
    textOverflow: "ellipsis",
    borderWidth: "1px !important",
    borderColor: "#E0E0E0 !important",
  },
}));

export const CMDropdownContainer = styled.div((props) => ({
  "& .MuiFormControl-root": {
    width: "100%",
    margin: "8px 0",
  },

  "& .notranslate": {
    display: "none",
  },

  "& .MuiSelect-select": {
    minHeight: "unset",
    color: props.theme.palette.gray["900"],
    fontFamily: props.theme.fontFamilies.jost,
    backgroundColor: "unset !important",
  },

  "& svg": {
    top: "50%",
    transform: "translateY(-50%)",
  },

  "& .Dropd": {
    "& .MuiFormControl-root": {
    width: "80% !important",
    margin: "8px 0",
  },

   
  }
  
  
}));
